/**
 * Статистика платежей эквайринга — разметка 1:1 с legacy
 * htdocs/core/templates/admin_payment_statistics.tpl: строка выбора месяца/года
 * (селекты в table.table) и таблица table.table.tdbottomborder с сырыми колонками payments.
 *
 * Данные: GET /api/admin/payment-statistics?month=&year=
 * (Handlers\Admin\Transactions::paymentStatistics). Legacy отправлял форму GET
 * при onchange селекта — здесь смена значения перезапрашивает данные (тот же эффект).
 */

import { useState } from 'react'

import { useLegacyCss } from '@/lib/legacyAssets'
import { useApi } from '@/lib/useApi'

/** Строка таблицы payments (выводится как есть — как в legacy-шаблоне). */
interface PaymentRow {
  id: number
  order_number: string | null
  position: string | null
  payment_type: string | null
  date_start: string | null
  date_end: string | null
  summ: string | null
  bank_mdorder: string | null
  bank_ordernumber: string | null
  period: string | null
}

/** Ответ GET /api/admin/payment-statistics. */
interface PaymentStatsResponse {
  payments: PaymentRow[]
  monthes: Record<string, string>
  years: Record<string, string>
  month: string
  year: string
}

export function AdminPaymentStatsPage() {
  useLegacyCss('admin', 'newapproach') // те же стили, что подключал legacy admin.tpl

  const now = new Date()
  const [month, setMonth] = useState(String(now.getMonth() + 1).padStart(2, '0'))
  const [year, setYear] = useState(String(now.getFullYear()))

  const { data } = useApi<PaymentStatsResponse>(
    `/api/admin/payment-statistics?month=${month}&year=${year}`,
  )

  const payments = data?.payments ?? []
  const monthes = data?.monthes ?? {}
  const years = data?.years ?? {}

  return (
    <>
      <div className="row" style={{ paddingTop: '20px' }}>
        <div className="col-xs-12 col-md-6">
          <table className="table" style={{ marginBottom: '0px' }}>
            <tbody>
              <tr>
                <td style={{ minWidth: '300px', height: '40px', verticalAlign: 'middle' }}>
                  Выберите дату
                </td>
                <td style={{ minWidth: '150px' }}>
                  <input type="hidden" name="group" value="0" />
                  <select
                    name="month"
                    className="form-control"
                    required
                    value={month}
                    onChange={(e) => setMonth(e.target.value)}
                  >
                    {Object.entries(monthes).map(([key, name]) => (
                      <option key={key} value={key}>
                        {name}
                      </option>
                    ))}
                  </select>
                </td>
                <td style={{ minWidth: '150px' }}>
                  <select
                    name="year"
                    className="form-control"
                    required
                    value={year}
                    onChange={(e) => setYear(e.target.value)}
                  >
                    {Object.entries(years).map(([key, name]) => (
                      <option key={key} value={key}>
                        {name}
                      </option>
                    ))}
                  </select>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <table className="table tdbottomborder">
        <thead>
          <tr>
            <td>id</td>
            <td>order_number</td>
            <td>position</td>
            <td>payment_type</td>
            <td>date_start</td>
            <td>date_end</td>
            <td>summ</td>
            <td>bank_mdorder</td>
            <td>bank_ordernumber</td>
            <td>period</td>
          </tr>
        </thead>
        <tbody>
          {payments.map((item) => (
            <tr key={item.id}>
              <td>{item.id}</td>
              <td>{item.order_number}</td>
              <td>{item.position}</td>
              <td>{item.payment_type}</td>
              <td>{item.date_start}</td>
              <td>{item.date_end}</td>
              <td>{item.summ}</td>
              <td>{item.bank_mdorder}</td>
              <td>{item.bank_ordernumber}</td>
              <td>{item.period}</td>
            </tr>
          ))}
          {payments.length < 1 && (
            <tr>
              <td colSpan={10} align="center">
                Нет данных по выбранному периоду
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  )
}
